




import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { dateTimeToDisplay, dateToNow } from '@/utils/dateTime'
import FoldingCard from '@/components/FoldingCard.vue'
@Component({
  components: {
    FoldingCard
  }
})
export default class AppSystemInfoCard extends Vue {
  @Prop({ type: String }) readonly createdBy!: string
  @Prop({ type: String }) readonly updatedBy!: string
  @Prop({ type: Number }) readonly createdAt!: number
  @Prop({ type: Number }) readonly updatedAt!: number
  @Prop({ type: Boolean, default: true }) readonly unFolding!: boolean

  systemInfoCard = [
    { title: 'Created By', content: ',-', subContent: '-', tooltip: '-' },
    { title: 'Last Modified By', content: ',-', subContent: '-', tooltip: '-' }
  ]

  mounted () {
    this.systemInfoCard[0].content = ', ' + dateToNow(this.createdAt)
    this.systemInfoCard[1].content = ', ' + dateToNow(this.updatedAt)
    this.systemInfoCard[0].subContent = this.createdBy
    this.systemInfoCard[1].subContent = this.updatedBy
    this.systemInfoCard[0].tooltip = dateTimeToDisplay(this.createdAt)
    this.systemInfoCard[1].tooltip = dateTimeToDisplay(this.updatedAt)
  }
}
